import { logs } from '@/translations/pl/blockly/logs' // skip-export

export const blockly = {
  editor: 'Edytor Reguł',
  editorDescription:
    'Za pomocą zmiennych i bloków możesz tworzyć reguły, które będą sterowały widokiem konfiguracji dla użytkownika.',
  variables: 'Zmienne',
  variablesFor: 'Zmienne dla {name}',
  variableList: 'Lista zmiennych',
  variableSearch: 'Wyszukaj',
  noVariablesFound: 'Brak zmiennych dla wybranego typu',
  goBack: 'Wróć',
  saveChanges: 'Zapisz',
  undo: 'Przywróć',
  unsavedChanges: 'Wprowadzono zmiany w regułach. Nie zapomnij ich zapisać.',
  unsavedChangesTitle: 'Niezapisane zmiany',
  unsavedChangesDescription:
    'Czy na pewno chcesz opuścić stronę? Wprowadzone zmiany nie zostaną zapisane.',
  undoOne: 'Cofnij 1 krok',
  undoAll: 'Cofnij wszystkie',
  form: {
    label: 'Nazwa',
    description: 'Opis',
  },
  success: {
    successTittle: 'Sukces!',
    ruleCreated: 'Utworzono regułę',
    ruleUpdated: 'Zaktualizowano regułę',
  },
  errors: {
    fetchFlowError: 'Błąd podczas pobierania flow',
    saveError: 'Błąd podczas zapisywania reguły',
    fetchPropertiesError: 'Błąd podczas pobierania właściwości',
  },
  toolbox: {
    categories: 'Kategorie',
    logic: 'Logika',
    math: 'Matematyka',
    variables: 'Wszystkie zmienne',
    text: 'Tekst',
    custom: 'Wygląd',
  },
  groupContainer: {
    label: 'Grupa: ',
    namePlaceholder: 'Nazwa',
    tooltip: 'Grupuje klocki wizualnie pod podaną nazwą.',
  },
  logs,
}
